// 搬入済QRをロット単位に表示する共通テーブル(材料名はマスタ解決)。

import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { DataLink, MasterLink } from "../../../components/links/EntityLinks";
import { extractUUIDTail } from "../../../util/uuidTextConverter";
import { carryInRow } from "../../../schema/console/carry_in";
import { MaterialsById, lotGroups } from "./helpers";

export function CarryInLotTable({ ci, materialsById }: { ci: carryInRow; materialsById: MaterialsById }) {
  const groups = lotGroups(ci);
  if (groups.length === 0) {
    return <Typography variant="caption" color="text.secondary">搬入QR なし</Typography>;
  }
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell sx={{ fontWeight: "bold" }}>材料ロット</TableCell>
          <TableCell sx={{ fontWeight: "bold" }}>材料</TableCell>
          <TableCell sx={{ fontWeight: "bold" }}>LotNo</TableCell>
          <TableCell sx={{ fontWeight: "bold" }} align="right">搬入QR数</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {groups.map((g) => (
          <TableRow key={g.lotId} hover>
            <TableCell>{g.carryOutId ? <DataLink type="lot" id={g.lotId} parentId={g.carryOutId} /> : `ロット ${extractUUIDTail(g.lotId)}`}</TableCell>
            <TableCell>{g.materialId != null ? <MasterLink type="material" id={g.materialId} name={materialsById.get(g.materialId)?.name ?? `#${g.materialId}`} /> : "-"}</TableCell>
            <TableCell>{g.lotNo ?? "-"}</TableCell>
            <TableCell align="right">{g.count}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
